<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.id ? activeAccount.id : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Pull account" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.pull_account ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Is fetched" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.is_fetched ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Last fetched" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.last_fetched ? tz(activeAccount.last_fetched) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Owner name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.owner_name ? activeAccount.owner_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Account name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.account_name ? activeAccount.account_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "IBAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.iban ? activeAccount.iban : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Currency" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.currency ? activeAccount.currency : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Swift" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.swift ? activeAccount.swift : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.status ? activeAccount.status : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Transactions count" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.transactions_count ? activeAccount.transactions_count : "0" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Related transactions count" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeAccount.related_transactions_count ? activeAccount.related_transactions_count : "0" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "consent-account-info-tab",
    data() {
        return {

        }
    },
    computed: {
        ...mapState('ais', ['activeAccount']),
    },
}
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>